import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import type { CSSProperties } from 'react';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import SessionTabsBar from '../SessionTabsBar';
import { useApp } from '../../hooks/useApp';
import { THEME_PALETTE } from '../../lib/theme';

// AppShell takes no props — it's the root layout rendered inside the router.

export default function AppShell(): JSX.Element {
  const { theme, density } = useApp();

  // Cast to CSSProperties so React's style prop accepts CSS custom properties
  // (the generated palette keys are all "--…" vars, which CSSProperties doesn't
  // explicitly type but tolerates at runtime).
  const themeVars = (THEME_PALETTE[theme] ?? THEME_PALETTE.dark) as CSSProperties;

  return (
    <div
      style={themeVars}
      className={clsx('flex flex-col h-screen overflow-hidden', theme, `density-${density}`)}
    >
      {/* TopBar — full viewport width, above everything */}
      <TopBar />

      {/* Below top bar: Sidebar + main content */}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        <Sidebar />

        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <main className="flex-1 flex flex-col overflow-hidden bg-surface-0">
            <div className="flex-1 overflow-hidden p-4">
              <Outlet />
            </div>
          </main>

          <SessionTabsBar />
        </div>
      </div>
    </div>
  );
}
